import { isObject } from '@utils/isObejct';
export function GetDisplayName(ApplicationName) {
    // FIXME: window['applications'] is used as global object need to pass this a param
    // pass this a to MFE's and other subapplications platform
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const servicesConfig = window['applications'];
    if (ApplicationName) {
        if (servicesConfig && isObject(servicesConfig[ApplicationName])) {
            return servicesConfig[ApplicationName].displayName;
        }
    }
    return ''
}

// const displayName = ServiceRequestAppDisplayName().toLowerCase();
// const appName = displayName.includes('your') ? displayName : `your ${displayName}`;
